/* eslint-disable no-restricted-syntax */
/* eslint-disable no-nested-ternary */
import {
  getPlatform,
  getURLParameters,
  isAndroid,
  isIOS,
  isPC,
  isWXMSG,
  isWXTIMELINE,
  parseCookie,
  parseQQ,
  setCookie,
} from './util';

export const EVENT_NAME = {
  Visit: 'page_visit',
  VideoPlay: 'video_play',
  Login: 'common_login',
  CoreAction: 'user_action',
  UserExposure: 'user_exposure',
  UserAction: 'user_action',
};

const fieldNameMapTable = {
  refUrl: 'ref_url',
  mainLogin: 'main_login',
  accountID: 'account_id',
  qqOpenID: 'qq_openid',
  appID: 'app_id',
  androidID: 'android_id',
  pageID: 'page_id',
  bucketID: 'bucket_id',
  testID: 'test_id',
  recommendID: 'recommend_id',
  networkType: 'network_type',
  extraInfo: 'extra_info',
  QQ: 'qq',
};

const NetworkTypeMap = {
  bluetooth: 'unknown',
  cellular: 'cellular',
  ethernet: 'unknown',
  none: 'none',
  mixed: 'unknown',
  other: 'unknown',
  unknown: 'unknown',
  wifi: 'wifi',
  wimax: 'unknown',
};
const NetworkEffectiveTypeMap = {
  '2g': '2g',
  '3g': '3g',
  '4g': '4g',
  'slow-2': '2g',
};
const ScenesPlatform = {
  other: 0,
  ws: 1,
  wxmsg: 2,
  wxtl: 3,
  qq: 4,
  qz: 5,
  wb: 6,
  wx: 7,
};

function getWSBeaconPersonID() {
  const personIDFieldName = 'person_id_wsbeacon';
  const cookie = parseCookie(document.cookie);

  if (cookie.person_id) return cookie.person_id;

  if (/^5\d{15}$/.test(cookie[personIDFieldName])) {
    return cookie[personIDFieldName];
  }

  const personID = `5${Math.random().toFixed(15)
    .replace(/^0\./, '')}`;
  setCookie(personIDFieldName, personID, document.domain, '/', 24 * 365 * 5);

  return personID;
}

const cookie = parseCookie(document.cookie);
const loginTypeMap = {
  1: 3,
  3: 2,
};

const getOpenId = (cookie, iAuthType, type) => {
  if (+iAuthType === type) {
    return cookie.weishiOpenid || cookie.openid || '';
  }
  return '';
};

const getScene = () => {
  const platform = getPlatform();
  let scene = ScenesPlatform[platform];
  if (scene === ScenesPlatform.wx) {
    if (isWXMSG) scene = ScenesPlatform.wxmsg;
    else if (isWXTIMELINE) scene = ScenesPlatform.wxtl;
  }
  return scene;
};

const commonParams = {
  common: {
    time: () => Date.now(),
    ua: navigator.userAgent,
    url: location.href,
    ref_url: document.referrer,
    os: isAndroid ? 1 : isIOS ? 2 : isPC ? 4 : 3,
    loginInfo: () => {
      const cookie = parseCookie(document.cookie);
      const { iAuthType } = cookie;
      const dataList = [
        { field: 'main_login', value: loginTypeMap[iAuthType] || 1 },
        { field: 'account_id', value: cookie.person_id || '' },
        { field: 'qq', value: parseQQ(cookie.uin || '') },
        {
          field: 'qq_openid',
          value: getOpenId(cookie, iAuthType, 1),
        },
        {
          field: 'wx_openid',
          value: getOpenId(cookie, iAuthType, 3),
        },
      ];
      return { dataType: 'multi-field', dataList };
    },
    /*
        qq: () => {
            let cookie = parseCookie(document.cookie);
            return parseQQ(cookie.uin || '');
        },
        qq_openid: () => {
            let cookie = parseCookie(document.cookie);
            return cookie.iAuthType == 1 ? (cookie.weishiOpenid || cookie.openid || '') : '';
        },
        */
    app_id: cookie.sThrAppid || '',
    /*
        wx_openid: () => {
            let cookie = parseCookie(document.cookie);
            return cookie.iAuthType == 3 ? (cookie.weishiOpenid || cookie.openid || '') : '';
        },
        */
    page_id: '',
    bucket_id: -1,
    test_id: -1,
    network_type: () => {
      const connection = navigator.connection || navigator.webkitConnection;
      let netType = NetworkTypeMap[connection && connection.type] || 'unknown';
      if (netType === 'cellular') {
        netType = NetworkEffectiveTypeMap[connection.effectiveType] || 'unknown';
      }
      return netType;
    },
    extra: '',
    mac: '',
    scenes_plat: getScene(),
    person_id_wsbeacon: () => getWSBeaconPersonID(),
    scenes_source: getURLParameters(location.href).scenes_source || '',
    scenes_from: getURLParameters(location.href).scenes_from || '',
  },
  android: {
    imei: '',
    imsi: '',
    android_id: '',
  },
  ios: {
    idfa: '',
    idfv: '',
  },
};

const tagCommonParams = {};

const currentPlatformCommonParams = {};

const readyListener = {};

// function fillParams(container, collecters = {}, list) {
//   for (const k in collecters) {
//     collecters[k].then((v) => {
//       if (typeof v === 'object') {
//         for (const tk in v) {
//           container[tk] = v[tk];
//         }
//       } else {
//         container[k] = v;
//       }
//     });
//     list.push(collecters[k]);
//   }
//   return list;
// }

function getCommonAndSysParams(paramMap = {}) {
  return {
    ...(paramMap.common || {}),
    ...(isAndroid ? paramMap.android || {} : isIOS ? paramMap.ios || {} : {}),
  };
}

/**
 * 聚合平台公共参数到currentPlatformCommonParams，
 * 包含三部分：commonParams/platformCommonParams/initCommonParams，
 * 后面的参数可以覆盖前面的参数
 */
export const mergeCommonParams = function (platformParams, initParams) {
  const curCommonParams = getCommonAndSysParams(commonParams);
  // let curPlatformParams = getCommonAndSysParams(platformParams);
  // let curInitParams = getCommonAndSysParams(initParams);
  const params = { ...curCommonParams, ...platformParams, ...initParams };
  console.log('mergeCommonParams before ready');
  flattenParams(params, (rp) => {
    Object.assign(currentPlatformCommonParams, rp);
    console.log('mergeCommonParams ready');
    (readyListener.paramsReady || []).forEach(callback => callback());
  });
};

/**
 * 参数打平，参数kv格式，v支持obj，promise，function，普通数据类型等形式
 * obj：若包含dataType='merge-data'则为聚合数据，否则做json字符串序列化
 * promise：说明数据需要经过异步获取，则异步获取后再做填充
 * function：数据需要实时获取，支持function运行后计算值
 * 普通数据类型：保持不变
 * @param {*} params
 */
function flattenParams(params, callback, options) {
  const resultParams = {};
  const promiseList = [];
  const promiseKeyList = [];
  Object.keys(params).forEach((key) => {
    let value = params[key];

    if (typeof value === 'function') {
      if (options && options.needExecFunction) {
        value = value();
        if (value instanceof Promise) {
          promiseList.push(value);
          promiseKeyList.push(key);
        } else {
          Object.assign(resultParams, formateParamValue(key, value));
        }
      } else {
        resultParams[key] = value;
      }
    } else if (value instanceof Promise) {
      console.log('promise found:', key, value);
      promiseList.push(value);
      promiseKeyList.push(key);
    } else if (typeof value === 'object') {
      Object.assign(resultParams, formateParamValue(key, value));
    } else {
      resultParams[key] = value;
    }
  });

  // 同步计算完毕给个回调返回，部分情况可以先设置，不需要等待异步计算了
  if (options && options.onSyncCalculationReady) {
    const syncParams = { ...resultParams };
    promiseList.forEach((item, index) => {
      syncParams[promiseKeyList[index]] = item;
    });
    options.onSyncCalculationReady(syncParams);
  }

  if (promiseList.length > 0) {
    console.log('flattenParams promiseList:', promiseList);
    Promise.all(promiseList)
      .then((valueList) => {
        console.log('flattenParams promise all resolve');
        valueList.forEach((value, index) => {
          Object.assign(resultParams, formateParamValue(promiseKeyList[index], value));
        });
        callback(resultParams);
      })
      .catch((e) => {
        console.error('promise exception found:', e);
        callback(resultParams);
      });
  } else {
    callback(resultParams);
  }
}

function formateParamValue(key, value) {
  const result = {};
  if (typeof value === 'object') {
    if (value.dataType === 'multi-field') {
      (value.dataList || []).forEach(item => (result[item.field] = item.value));
    } else {
      result[key] = JSON.stringify(value);
    }
  } else {
    result[key] = value;
  }
  return result;
}

export const registerReadyListener = function (name, callback) {
  !readyListener[name] && (readyListener[name] = []);
  readyListener[name].push(callback);
};

export const getParams = function () {
  const sysParams = isAndroid ? commonParams.android : isIOS ? commonParams.ios : {};
  return { ...commonParams.common, ...sysParams };
};

export const mergeParams = function (tag, params, callback) {
  if (!tagCommonParams[tag]) {
    console.error('undefined tag:', tag);
    return;
  }

  // eslint-disable-next-line no-param-reassign
  params = {
    ...currentPlatformCommonParams,
    ...(tagCommonParams[tag].params || {}),
    ...params,
  };
  console.log('mergeParams:', params, currentPlatformCommonParams, tagCommonParams[tag].params);
  flattenParams(
    params,
    (params) => {
      const resultParams = {};
      for (const key in params) {
        if (fieldNameMapTable[key]) {
          resultParams[fieldNameMapTable[key]] = params[key];
        } else {
          resultParams[key] = params[key];
        }
      }
      callback && callback(tagCommonParams[tag].event, resultParams);
    },
    { needExecFunction: true },
  );
};

export const mergeRealParams =  function (tag, params) {
  const  newParams = {
    ...currentPlatformCommonParams,
    ...(tagCommonParams[tag].params || {}),
    ...params,
  };
  const options = { needExecFunction: true };
  const resultParams = {};
  const promiseList = [];
  const promiseKeyList = [];
  Object.keys(newParams).forEach((key) => {
    let value = newParams[key];

    if (typeof value === 'function') {
      if (options && options.needExecFunction) {
        value = value();
        if (value instanceof Promise) {
          promiseList.push(value);
          promiseKeyList.push(key);
        } else {
          Object.assign(resultParams, formateParamValue(key, value));
        }
      } else {
        resultParams[key] = value;
      }
    } else if (value instanceof Promise) {
      console.log('promise found:', key, value);
      promiseList.push(value);
      promiseKeyList.push(key);
    } else if (typeof value === 'object') {
      Object.assign(resultParams, formateParamValue(key, value));
    } else {
      resultParams[key] = value;
    }
  });

  return { eventName: tagCommonParams[tag].event, eventData: resultParams };
}

export const setFieldNameMap = (map) => {
  for (const k in map) {
    fieldNameMapTable[k] = map[k];
  }
};

export const setEventParams = (params, options) => {
  for (const eventName in params) {
    const tagParams = params[eventName];
    for (const tag in tagParams) {
      if (!tagCommonParams[tag]) {
        tagCommonParams[tag] = {
          event: eventName,
          params: {},
        };
      } else if (options && options.dupcatedWarn) {
        console.warn('duplicated tag found:', tag);
      }
      tagCommonParams[tag].event = eventName;
      flattenParams(
        tagParams[tag],
        (resultParams) => {
          const tagParams = tagCommonParams[tag].params;
          for (const key in resultParams) {
            if (tagParams[key] === undefined || (options && options.overwrite)) {
              tagParams[key] = resultParams[key];
            }
          }
        },
        {
          onSyncCalculationReady: (syncParams) => {
            if (options && options.syncWriteOnce) {
              Object.assign(tagCommonParams[tag].params, syncParams);
            }
          },
        },
      );
    }
  }
};

function updateParams(params, source, options) {
  for (const key in source) {
    if (params[key] !== undefined) {
      if (options && options.overwrite) {
        if (source[key] === undefined) {
          // eslint-disable-next-line no-param-reassign
          delete params[key];
        } else {
          // eslint-disable-next-line no-param-reassign
          params[key] = source[key];
        }
      }
    } else {
      if (source[key] !== undefined) {
        // eslint-disable-next-line no-param-reassign
        params[key] = source[key];
      }
    }
  }
}

export const setCommonParams = (params, options) => {
  flattenParams(params, (resultParams) => {
    updateParams(currentPlatformCommonParams, resultParams, options);
  });
};
